import { api_GET, api_POST, api_PUT } from "../api/_axios.js";

const categoriafiscalizacao_api =
{
    getAll: function () {
        const promise = new Promise((resolve, reject) => {
            api_GET(`categoriafiscalizacao`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    getItem: function (id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`categoriafiscalizacao/getItem/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    postCategoria: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`categoriafiscalizacao/Insert`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    putCategoria: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`categoriafiscalizacao/Update`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default categoriafiscalizacao_api;
